import "@radix-ui/themes/styles.css";
import "./styles/global.css";
import "@/lib/i18n"; // initialise i18next globalement avant tout

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";

// Enregistrement du service worker (PWA)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn("SW registration failed:", err);
    });
  });
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
